import { useTranslation } from 'react-i18next'

type SMSSubTextProps = {
  className: string
}

const SMSSubText = ({ className, ...props }: SMSSubTextProps) => {
  const { t } = useTranslation()

  return (
    <p className={className} {...props}>
      {t('sms.subtext')}
    </p>
  )
}

export default SMSSubText
